import { Link, NavLink } from "react-router-dom";
import Arrow from "../SVG/ArrowSvg";
import DownloadIcon from "../SVG/Download";

import "./button.scss";

type ButtonProps = {
  label?: string;
  className?: string;
  onClick?: () => void;
  link?: string;
  icon?: string;
  target?: string;
  emailType?: string;
  noIcon?: boolean;
  activeDot?: boolean;
};

const Button = ({
  label,
  className,
  link,
  icon,
  target,
  emailType,
  noIcon,
  activeDot,
  onClick,
}: ButtonProps) => {
  function getLink() {
    if (emailType === "email") {
      link = `mailto:${link}`;
    }
    return link;
  }
  getLink();

  // Interne routes zijn altijd relatief (beginnen met "/"); externe/mailto/tel
  // links zijn dat nooit. Op basis daarvan kiezen we automatisch NavLink i.p.v.
  // Link, zodat dit niet per plek waar Button gebruikt wordt onthouden hoeft
  // te worden.
  const isInternal = Boolean(link && link.startsWith("/"));

  const iconElement = noIcon ? null : icon === "arrow" ? (
    <Arrow className="icon-arrow" />
  ) : icon === "download" ? (
    <DownloadIcon className="icon-download" />
  ) : icon === "arrow-menu" ? (
    <Arrow className="icon-arrowMenu" />
  ) : icon === "arrow-footer" ? (
    <Arrow className="icon-arrowFooter" />
  ) : null;

  const textClassName = `text${noIcon ? " no-icon" : ""}${
    icon === "arrow-menu" ? " menu" : ""
  }`;

  if (isInternal) {
    return (
      <NavLink
        to={link ? link : ""}
        className={`button ${className || ""}`}
        onClick={onClick}
      >
        {({ isActive }) => (
          <>
            {iconElement}
            {activeDot ? (
              <div className="position">
                <p className={textClassName}>{label}</p>
                <div className={isActive ? "dot active" : "dot inActive"} />
              </div>
            ) : (
              <p className={textClassName}>{label}</p>
            )}
          </>
        )}
      </NavLink>
    );
  }

  return (
    <Link
      to={link ? link : ""}
      target={target ? target : "_none"}
      className={`button ${className || ""}`}
      onClick={onClick}
    >
      {iconElement}
      <p className={textClassName}>{label}</p>
    </Link>
  );
};

export default Button;
